import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileUpload } from './file-upload';

@Component({
    selector: 'eas-file-upload-control-upload-list-item',
    template: `
    <mat-list-item>
    <p matLine>
      {{ upload.filename }} {{ upload.size | storage }} &nbsp;
      <button type="button" mat-button color="warn" *ngIf="canRemove(upload)" (click)="onRemove(upload)">
        <mat-icon>remove</mat-icon> <span i18n>Remove</span>
      </button>
      <span style="float: right">
        <button mat-button type="button" color="primary" *ngIf="canPreview(upload)" (click)="onPreview(upload)" i18n>Preview</button>
        <button mat-button type="button" color="primary" *ngIf="canDownload(upload)" (click)="onDownload(upload)" i18n>Download</button>
      </span>
      <span *ngIf="isInProgress(upload)" style="float:right">
        <ng-container i18n>Uploading...</ng-container>
        <mat-progress-spinner style="margin-left: 10px; float:right"
                              diameter="20"
                              mode="determinate"
                             [value]="upload.progress"></mat-progress-spinner>
      </span>
      <span *ngIf="didFail(upload)" style="float:right">
        <ng-container i18n>Upload failed</ng-container> <mat-icon matListIcon>report_problem</mat-icon>
      </span>
    </p>
    </mat-list-item>
    `,
    standalone: false
})
export class FileUploadControlUploadListItemComponent  {
  @Input() upload!: FileUpload;
  @Input() isEditable!: boolean;
  @Output() downloadRequested = new EventEmitter<FileUpload>();
  @Output() previewRequested = new EventEmitter<FileUpload>();
  @Output() removalRequested = new EventEmitter<FileUpload>();

  onDownload(upload: FileUpload) {
      this.downloadRequested.emit(upload);
  }

  onPreview(upload: FileUpload) {
      this.previewRequested.emit(upload);
  }

  onRemove(upload: FileUpload) {
    this.removalRequested.emit(upload);
  }

  canDownload(upload: FileUpload): boolean {
    return upload.state === 'successful';
  }

  canPreview(upload: FileUpload): boolean {
    if (upload.state !== 'successful') {
      return false;
    }

    if (upload.contentType.startsWith('image/') || upload.contentType.includes('pdf')) {
      return true;
    }

    if (['jpg', 'jpeg', 'png', 'gif', 'pdf'].some(ext => upload.filename.endsWith(ext))) {
      return true;
    }

    return false;
  }

  canRemove(upload: FileUpload): boolean {
    return this.isEditable && upload.state === 'successful';
  }

  didFail(upload: FileUpload): boolean {
      return upload.state === 'failed';
  }

  isInProgress(upload: FileUpload): boolean {
      return upload.state === 'in-progress';
  }
}
